import styled from 'styled-components';

const StyledReportFlagIcon = styled.svg<{ width?: number; height?: number }>`
  width: ${({ width }) => (width ? `${width}rem` : '1.6rem')};
  height: ${({ width }) => (width ? `${width}rem` : '1.6rem')};

  /* @media (max-width: 768px) {
    width: 2.4rem;
    height: 2.4rem;
  } */
`;

const ReportFlagIcon = ({ width, height }: { width?: number; height?: number }) => {
  return (
    <StyledReportFlagIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={width}
      height={height}
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
      <line x1="4" y1="22" x2="4" y2="15"></line>
    </StyledReportFlagIcon>
  );
};

export default ReportFlagIcon;
